import React, { FC, useState } from 'react';
import { getData } from './data';
import { useTranslation } from 'react-i18next';
import {
    Answer,
    AnswersBlock,
    BackButton,
    ButtonBlock,
    Content,
    Question,
    Title,
} from './styled';
import { Question as QuestionType } from '../../types';
import { langMapperType } from 'utils/lang-convert';

export const QuizModal: FC = () => {
    const { t, i18n } = useTranslation(['pages/quiz', 'common/shared']);
    const langDomain = langMapperType[i18n.language]
        ? langMapperType[i18n.language]
        : langMapperType['en'];
    const [app, setApp] = useState(getData(langDomain));

    const selectEl = (next: QuestionType) => {
        if (next?.link) {
            window.location.href = next?.link;
            return;
        }
        if (next?.select) {
            next?.select();
            return;
        }
        setApp(next);
    };

    const prev = (prev?: QuestionType) => {
        if (!prev) return;

        setApp(prev);
    };

    return (
        <Content>
            <Title>{t(`pages/quiz:${app.title}`)}</Title>
            {app.question && (
                <Question>{t(`pages/quiz:${app.question}`)}</Question>
            )}
            {app.next && app.next.length !== 0 && (
                <AnswersBlock>
                    {app.next?.map((a) => (
                        <Answer key={a.id} onClick={() => selectEl(a)}>
                            {a.answer && t(`pages/quiz:${a.answer}`)}
                        </Answer>
                    ))}
                </AnswersBlock>
            )}
            {app.component && (
                <app.component
                    back={() => prev(app.prev)}
                    link={app.nextLink}
                    title={app.nextTitle}
                />
            )}
            {app.prev && !app.component && (
                <ButtonBlock>
                    <BackButton onClick={() => prev(app.prev)}>
                        {t('pages/quiz:back')}
                    </BackButton>
                </ButtonBlock>
            )}
        </Content>
    );
};
